import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import ConfirmDialog, { IConfirmDialog } from '../../components/form/controls/ConfirmDialog';
import { LightToolTip } from '../../components/form/react-hook-form-components/ToolTipTheme';
import PriorityQueries from './PriorityQueries';
import { Employee } from '../../models/Employee';

interface IDeletePriorityProps {
  id: number;
  employee: Employee;
}

function DeletePriorityButton(props: IDeletePriorityProps) {
  const { id, employee } = props;
  const { mutateDeletePriority } = PriorityQueries();
  const [deleteDialog, setDeleteDialog] = useState({
    isOpen: false,
    title: '',
    content: '',
  } as IConfirmDialog);

  /**
   * Handles deletion of priorities
   */
  const handleDeletePriority = () => {
    setDeleteDialog({
      isOpen: true,
      title: `Are you sure you want to delete this Priority for ${employee.firstName} ${employee.lastName}?`,
      content: "You can't undo this operation",
      onConfirm: () => {
        mutateDeletePriority(id, {
          onSuccess: closeDeleteDialog,
        });
      },
    } as IConfirmDialog);
  };

  /**
   * Closes the delete dialog
   */
  const closeDeleteDialog = () => {
    setDeleteDialog({
      ...deleteDialog,
      isOpen: false,
    });
  };

  return (
    <div>
      <LightToolTip title="Delete" placement="bottom">
        <IconButton color="secondary" onClick={() => handleDeletePriority()}>
          <DeleteIcon />
        </IconButton>
      </LightToolTip>

      <ConfirmDialog confirmDialog={deleteDialog} setConfirmDialog={setDeleteDialog} />
    </div>
  );
}

export default DeletePriorityButton;
